import { render, staticRenderFns } from "./ProjectList.vue?vue&type=template&id=2828b219&scoped=true"
import script from "./ProjectList.vue?vue&type=script&lang=js"
export * from "./ProjectList.vue?vue&type=script&lang=js"
import style0 from "./ProjectList.vue?vue&type=style&index=0&id=2828b219&prod&lang=less&scoped=true"
import style1 from "./ProjectList.vue?vue&type=style&index=1&id=2828b219&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2828b219",
  null
  
)

export default component.exports